<template>
  <svg
    v-bind="$attrs"
    :width="width"
    :height="height"
    viewBox="0 0 37 37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M30.8333 20.5556C33.1006 20.5556 34.9444 22.3994 34.9444 24.6667V26.7222H37V33.9167C37 35.6166 35.6166 37 33.9167 37H27.75C26.0501 37 24.6667 35.6166 24.6667 33.9167V26.7222H26.7222V24.6667C26.7222 22.3994 28.5661 20.5556 30.8333 20.5556ZM15.4167 0C17.1639 0 18.87 0.493333 20.3294 1.41833C20.905 1.76777 21.46 2.19944 21.9533 2.69277C22.8989 3.63833 23.5875 4.75244 24.0356 5.96523C24.2535 6.55106 24.4364 7.14923 24.5331 7.77823L24.5762 8.05983L24.6461 8.44833L24.6358 8.4545V8.4586L23.6204 9.0835C22.7591 9.64056 21.7807 10.2696 19.8998 10.2757C19.8916 10.2757 19.8854 10.2778 19.8772 10.2778C19.4044 10.2778 18.9892 10.2367 18.6192 10.1688C18.6069 10.1668 18.5987 10.1627 18.5863 10.1606C17.501 9.953 16.7939 9.50077 16.1526 9.0876C15.9676 8.96633 15.7908 8.85327 15.6099 8.74844C15.6099 8.74844 14.4937 8.22223 13.5256 8.22223H13.5194C12.4053 8.22427 11.8092 8.5285 11.1802 8.9211C11.0938 8.9766 11.0096 9.02594 10.9212 9.0835C10.8616 9.12256 10.7917 9.16367 10.73 9.20273C10.6087 9.28083 10.4854 9.35894 10.3518 9.43706C10.2654 9.48844 10.1688 9.53367 10.0763 9.583C9.94273 9.65289 9.80706 9.72073 9.657 9.78444C9.52956 9.842 9.39183 9.89133 9.25 9.94067C9.11639 9.9859 8.97044 10.0229 8.82244 10.0619C8.64977 10.1072 8.47917 10.1503 8.28594 10.1812C8.26333 10.1853 8.24483 10.1914 8.22223 10.1956V11.3056C8.22223 11.6344 8.24277 11.9633 8.30444 12.2717C8.75667 15.7867 11.7783 18.5 15.4167 18.5C19.1783 18.5 22.2822 15.5811 22.57 11.9017C23.495 11.6139 24.1528 11.1822 24.6667 10.8533V11.3056C24.6667 14.4958 23.0407 17.3139 20.5741 18.9769H20.6686C22.6 19.2999 24.4972 19.8015 26.3358 20.4754C25.308 21.5772 24.6667 23.0428 24.6667 24.6667H22.6111V33.9167C22.6111 33.9434 22.6193 33.9681 22.6193 33.9968C19.8649 34.7204 17.3694 34.9444 15.4167 34.9444C8.75873 34.9444 3.6219 32.6258 0.485105 30.6792L0 30.377V26.5927C0 23.8938 1.65473 21.5237 4.2139 20.5556C6.14817 19.8217 8.15644 19.3037 10.1914 18.9687H10.2839C8.0845 17.4866 6.53667 15.1042 6.22833 12.3333C6.18723 12.0044 6.16667 11.655 6.16667 11.3056V9.25C6.16667 8.16056 6.35167 7.13277 6.7011 6.16667C7.97556 2.56944 11.4083 0 15.4167 0ZM30.8333 22.6111C29.7007 22.6111 28.7778 23.5341 28.7778 24.6667V26.7222H32.8889V24.6667C32.8889 23.5341 31.9659 22.6111 30.8333 22.6111Z"
      :fill="fill"
    />
    <ellipse
      cx="15.4167"
      cy="13.1042"
      rx="8.47917"
      ry="6.16667"
      :fill="fill"
    />
    <rect
      x="22.3542"
      y="8.47754"
      width="2.3125"
      height="3.08333"
      :fill="fill"
    />
  </svg>
</template>

<script lang="ts" setup>
const props = defineProps({
  width: {
    type: [String, Number],
    default: 37,
  },
  height: {
    type: [String, Number],
    default: 37,
  },
  fill: {
    type: String,
    default: 'currentColor',
  },
});
</script>
